import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

export default function ClearFilterButton({
  label,
  onClick,
  sx,
  variant = 'contained',
  color = 'warning',
}) {
  return (
    <Button
      variant={variant}
      color={color}
      onClick={onClick}
      startIcon={<FilterAltOffIcon />}
      sx={sx}
    >
      {label}
    </Button>
  );
}

ClearFilterButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
